export default "skymp5-front/63f3fd0146efd97bd7d54bfda8ea7cf0.png";